import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WP_NUMBER  = '970567960006';
const EMAIL_TO   = 'info@wiz-tech.co';

const Contact = () => {
    const { t, i18n } = useTranslation();
    const isAr = i18n.language === 'ar';

    const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

    const set = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));

    const handleEmail = (e) => {
        e.preventDefault();
        const subject = encodeURIComponent(form.subject || 'Contact from WIZ website');
        const body    = encodeURIComponent(
            `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
        );
        window.location.href = `mailto:${EMAIL_TO}?subject=${subject}&body=${body}`;
    };

    const handleWhatsApp = (e) => {
        e.preventDefault();
        const text = encodeURIComponent(
            `Hello WIZ 👋\n\nName: ${form.name}\nEmail: ${form.email}\nSubject: ${form.subject}\n\n${form.message}`
        );
        window.open(`https://wa.me/${WP_NUMBER}?text=${text}`, '_blank');
    };

    const glass = {
        background: 'rgba(10, 10, 18, 0.55)',
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: '24px',
    };

    const inputStyle = {
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)',
        color: '#fff',
        padding: '14px 16px',
        borderRadius: '12px',
        outline: 'none',
        transition: 'border-color 0.3s',
        width: '100%',
    };

    const INFO = [
        { icon: 'fas fa-map-marker-alt', label: t("Headquarters"), value: 'Palestine, Gaza, Jalaa st, Watan Building 1107' },
        { icon: 'fas fa-phone',          label: t("Call Us"),      value: '+970 595 151 005', href: 'tel:+970595151005' },
        { icon: 'fab fa-whatsapp',       label: 'WhatsApp',        value: '+970 567 960 006', href: `https://wa.me/${WP_NUMBER}` },
        { icon: 'fas fa-envelope',       label: t("Email Us"),     value: EMAIL_TO,           href: `mailto:${EMAIL_TO}` },
    ];

    return (
        <>
            {/* Hero */}
            <section style={{ padding: '170px 0 60px', textAlign: 'center', background: 'transparent' }}>
                <div className="container">
                    <h1 style={{ color: '#fff', fontSize: '3.5rem', marginTop: '15px' }}>
                        {t("Get in")} <span style={{ color: '#45d0bd' }}>{t("Touch")}</span>
                    </h1>
                    <p style={{ color: '#6b6b88', maxWidth: '600px', margin: '20px auto 0' }}>
                        {t("Have a complex engineering challenge? Let's discuss how WIZ can build your next intelligent system.")}
                    </p>
                </div>
            </section>

            {/* Contact grid */}
            <section style={{ background: 'transparent', padding: '60px 0 100px' }}>
                <div className="container">
                    <div className="row">

                        {/* Info */}
                        <div className="col-lg-5 mb-5 mb-lg-0">
                            <div className="tilt-card" style={{ ...glass, padding: '40px', height: '100%' }}>
                                <h3 style={{ color: '#fff', marginBottom: '30px' }}>{t("Contact Information")}</h3>
                                {INFO.map((item, i) => (
                                    <div key={i} className="d-flex align-items-start mb-4">
                                        <div style={{
                                            width: '50px', height: '50px', flexShrink: 0,
                                            background: 'rgba(69,208,189,0.1)', borderRadius: '12px',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            color: '#45d0bd', marginRight: isAr ? 0 : '15px', marginLeft: isAr ? '15px' : 0,
                                        }}>
                                            <i className={item.icon}></i>
                                        </div>
                                        <div>
                                            <h6 style={{ color: '#6b6b88', margin: 0, fontSize: '0.85rem' }}>{item.label}</h6>
                                            {item.href
                                                ? <a href={item.href} target={item.href.startsWith('http') ? '_blank' : undefined}
                                                     rel="noopener noreferrer"
                                                     style={{ color: '#fff', fontWeight: '600', textDecoration: 'none' }}>
                                                      {item.value}
                                                  </a>
                                                : <span style={{ color: '#fff', fontWeight: '600' }}>{item.value}</span>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Form */}
                        <div className="col-lg-7">
                            <div className="tilt-card" style={{ ...glass, padding: '40px' }}>
                                <h3 style={{ color: '#fff', marginBottom: '30px' }}>{t("Send a Message")}</h3>
                                <form>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <input type="text" placeholder={t("Your Name")} style={inputStyle}
                                                value={form.name} onChange={set('name')} />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <input type="email" placeholder={t("Email Address")} style={inputStyle}
                                                value={form.email} onChange={set('email')} />
                                        </div>
                                        <div className="col-12 mb-3">
                                            <input type="text" placeholder={t("Subject")} style={inputStyle}
                                                value={form.subject} onChange={set('subject')} />
                                        </div>
                                        <div className="col-12 mb-4">
                                            <textarea rows="5" placeholder={t("Project Details / Message")} style={inputStyle}
                                                value={form.message} onChange={set('message')} />
                                        </div>

                                        {/* Two submit buttons */}
                                        <div className="col-md-6 mb-3">
                                            <button onClick={handleEmail} style={{
                                                background: 'linear-gradient(135deg, #45d0bd 0%, #4a9eff 100%)',
                                                color: '#fff', border: 'none', borderRadius: '14px', padding: '14px',
                                                fontWeight: '600', fontSize: '1rem', width: '100%', cursor: 'pointer',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                                            }}>
                                                <i className="fas fa-envelope" />
                                                {isAr ? 'إرسال بالبريد' : 'Send via Email'}
                                            </button>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <button onClick={handleWhatsApp} style={{
                                                background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
                                                color: '#fff', border: 'none', borderRadius: '14px', padding: '14px',
                                                fontWeight: '600', fontSize: '1rem', width: '100%', cursor: 'pointer',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                                            }}>
                                                <i className="fab fa-whatsapp" />
                                                {isAr ? 'إرسال عبر واتساب' : 'Send via WhatsApp'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;
